<template>
  <v-col class="px-0 py-1">
    <v-list-item :to="{ name: item.link }" link color v-if="item.link">
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-group no-action color v-model="item.active" v-if="item.links">
      <template v-slot:activator>
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item
        v-for="subitem in item.links"
        :key="subitem.title"
        :to="{ name: subitem.link }"
        @click="clicked(item)"
        link
      >
        <v-list-item-action>
          <v-icon>{{ subitem.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ subitem.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-col>
</template>

<script>
export default {
  data: () => ({}),
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clicked() {
      //item.active = false;
    },
    clickedActivator(item) {
      console.log(item)
    }
  },
  watch: {},
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mini: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
</style>